export const openIdProviderConfigPath = 'oidc/.well-known/openid-configuration';
export const openIdProviderPath = 'oidc';
